/*require('./../../../style/input-plugin/image.less');*/
var $ = require('jQuery');
var template = require('./../../../template/input-plugin/image.html');
var Plugin = require('./Plugin');
//var stat = require('./../../../global/stat');
//var StatPoint = require('./../../../constant/StatPoint');


var ImagePlugin = function (options) {
    (function (self) {
        var defaults = {
            template: template
        };
        $.extend(defaults, options);
        Plugin.call(self, defaults);

        self._element.find('.im-image-icon').click(function () {
            //上传图片
            self._element.find('.im-image-choose').trigger('click');
            //埋点统计（图片按钮点击）
            //stat.report(StatPoint.img_btn_click);
            if(window.WMDA_REPORT){
                window.WMDA_REPORT('custom',{event_id:'7'})
            }
        });

        self._element.on('change', ".im-image-choose", (function () {
            if (this.files.length === 0) {
                return;
            }
            self._input.imgSend(this.files[0]);
            this.outerHTML = this.outerHTML;
            //埋点统计（图片发送）
            //stat.report(StatPoint.img_send);
            if(window.WMDA_REPORT){
                window.WMDA_REPORT('custom',{event_id:'8'})
            }
        }));

    })(this);
};
ImagePlugin.prototype = Object.create(Plugin.prototype);

module.exports = ImagePlugin;
